import { Text, Grid, GridItem, Hide, Show, Box } from '@everlywell/ui-kit';
import RichTextWrapper from 'components/RichTextWrapper';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { ImageType } from 'utils/types';

import SectionContainer from '../components/SectionContainer';

export type SplitCardSectionProps = {
  eyebrow?: string | null;
  body?: any;
  desktopImage?: ImageType | null;
  mobileImage?: ImageType | null;
  description?: string | null;
};

/**
 * This section is used to render the Split Card section on the EHS marketing page.
 */
const SplitCardSection = ({
  eyebrow,
  body,
  description,
  desktopImage,
  mobileImage,
}: SplitCardSectionProps) => {
  if (!eyebrow && !body && !description && !desktopImage && !mobileImage)
    return null;

  return (
    <SectionContainer size={['sm', 'sm', 'xl']} overflow="clip">
      <Grid flexDirection={['column-reverse', null, 'row']}>
        <GridItem width={[1, null, 0.5]} display="flex" justifyContent="center">
          {/* render desktop image if it exists */}
          <Box position="sticky">
            {desktopImage?.gatsbyImageData && (
              <Show above="tablet">
                <GatsbyImage
                  image={desktopImage.gatsbyImageData}
                  alt={desktopImage.description ?? ''}
                />
              </Show>
            )}
            {/* render mobile image if it exists */}
            {mobileImage?.gatsbyImageData && (
              <Hide above="tablet">
                <GatsbyImage
                  image={mobileImage.gatsbyImageData}
                  alt={mobileImage.description ?? ''}
                />
              </Hide>
            )}
          </Box>
        </GridItem>
        <GridItem
          width={[1, null, 0.5]}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          maxWidth={[null, null, '390px']}
          marginX="auto"
        >
          {eyebrow && (
            <Text
              color="viridian.base"
              paddingBottom={3}
              textAlign={['center', null, 'start']}
            >
              {eyebrow}
            </Text>
          )}

          {body?.raw && (
            <Box textAlign={['center', null, 'start']}>
              <RichTextWrapper contentfulRichText={body} />
            </Box>
          )}

          {description && (
            <Box textAlign={['center', null, 'start']}>
              <Text size="lg" color="tints.darkGrey">
                {description}
              </Text>
            </Box>
          )}
        </GridItem>
      </Grid>
    </SectionContainer>
  );
};

export default SplitCardSection;
